'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

var _overlayMenu = require('../components/overlayMenu');

var _overlayMenu2 = _interopRequireDefault(_overlayMenu);

var _gforms = require('../components/gforms');

var _gforms2 = _interopRequireDefault(_gforms);

var _scrollEvents = require('../components/scrollEvents');

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _sitePopup = require('../components/sitePopup');

var _sitePopup2 = _interopRequireDefault(_sitePopup);

var _sitePopupSeasonal = require('../components/sitePopupSeasonal');

var _sitePopupSeasonal2 = _interopRequireDefault(_sitePopupSeasonal);

var _ui = require('@fancyapps/ui');

var _utm = require('../components/utm');

var _utm2 = _interopRequireDefault(_utm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  init: function init() {
    var _this = this;

    // JavaScript to be fired on all pages

    if (document.readyState === 'complete') {
      this.onDocumentLoaded();
    } else {
      window.addEventListener('load', function () {
        _this.onDocumentLoaded();
      });
    }

    // this.map.init();
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  onDocumentLoaded: function onDocumentLoaded() {
    // Javascript to be loaded after all content has loaded
    _overlayMenu2.default.init();
    _scrollEvents2.default.init();
    _gforms2.default.init();
    _sitePopup2.default.init();
    _sitePopupSeasonal2.default.init();
    // swiper.init();
    this.goBack();
    this.fancyBox();
    this.counter();
    this.scrollTo();
    this.toggleNavList();
    this.constructionStageActions();
    this.passwordpage();
    this.latestNewsSlider();
    this.offersLandCards();
    // flicking.init();
    _utm2.default.init();
  },
  constructionStageActions: function constructionStageActions() {
    var progressBars = document.querySelectorAll('.stage-works-item-progress-bar');
    var progressCircle = document.querySelector('.progress-ring-circle');

    if (progressBars && progressBars.length > 0) {
      setTimeout(function () {
        progressBars.forEach(function (bar) {
          return bar.classList.add('active');
        });
      }, 100);
    }

    if (progressCircle) {
      var progressVal = progressCircle.dataset.percent;
      var strokeVal = 5.24 * 100 / 100;
      progressCircle.style.strokeDasharray = progressVal * strokeVal + ' 999';
    }
  },
  toggleNavList: function toggleNavList() {
    var navs = document.querySelectorAll('.toggle-nav-list');

    if (navs && navs.length > 0) {
      navs.forEach(function (nav) {
        var trigger = nav.querySelector('button');

        trigger.addEventListener('click', function (e) {
          nav.classList.toggle('show');
        });
      });
    }
  },
  goBack: function goBack() {
    var links = document.querySelectorAll('.go-back-link');

    if (links) {
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var referrer = document.referrer;
          var linkUrl = new URL(e.currentTarget.href);

          if (referrer) {
            var referrerPaths = new URL(referrer);
            if (referrerPaths.host === location.host && referrerPaths.pathname === linkUrl.pathname) {
              history.back();
            } else {
              location = linkUrl;
            }
          } else {
            location = linkUrl;
          }
        });
      });
    }
  },
  fancyBox: function fancyBox() {
    _ui.Fancybox.bind('[data-fancybox]', {
      dragToClose: false
    });
  },
  counter: function counter() {
    var counters = document.querySelectorAll('.counter');

    if (!counters || counters.length === 0) return;

    counters.forEach(function (counter) {
      _scrollEvents2.default.inViewCounters(counter);
    });
  },
  scrollTo: function scrollTo() {
    var triggers = document.querySelectorAll('[href*="scrollto"], .scroll-to');

    var doScroll = function doScroll(el) {
      el.preventDefault();

      var url = new URL(el.currentTarget.href);

      if (url && typeof url.hash !== 'undefined') {
        var target = document.querySelector(url.hash.replace('scrollto-', ''));

        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    if (triggers && triggers.length > 0) {
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', doScroll);
      });
    }
  },
  passwordpage: function passwordpage() {
    var forms = document.querySelectorAll('.post-password-form');

    if (forms && forms.length) {
      forms.forEach(function (form) {
        var pw_input = form.querySelector('input[type=password]');
        console.log(pw_input);

        pw_input.addEventListener('focus', function (event) {
          event.currentTarget.parentNode.classList.add('is-focused');
        }, true);

        pw_input.addEventListener('blur', function (event) {
          event.currentTarget.parentNode.classList.remove('is-focused');
        }, true);
      });
    }
  },
  latestNewsSlider: function latestNewsSlider() {
    var latestNewsSliders = document.querySelectorAll('.latest-news-carousel-container');

    var doLatestNewsSlider = function doLatestNewsSlider(slider) {
      new _swiper2.default(slider, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        breakpoints: {
          560: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20
          },
          980: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1080: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    };

    if (latestNewsSliders && latestNewsSliders.length > 0) {
      latestNewsSliders.forEach(function (slider) {
        doLatestNewsSlider(slider);
      });
    }
  },
  offersLandCards: function offersLandCards() {
    var landCardsContainer = document.getElementById('land-cards-bottom');
    var landCardsTrigger = document.querySelector('.land-cards-cta');

    if (landCardsContainer) {
      landCardsTrigger.addEventListener('click', function (e) {
        e.preventDefault();

        if (landCardsContainer.classList.contains('hidden')) {
          landCardsContainer.classList.remove('hidden');
          landCardsTrigger.classList.add('active');
          landCardsTrigger.querySelector('span').textContent = 'Hide Available Lots';
        } else {
          landCardsContainer.classList.add('hidden');
          landCardsTrigger.classList.remove('active');
          landCardsTrigger.querySelector('span').textContent = 'Show Available Lots';
        }
      });
    }
  }
};
// import swiper from '../components/swiper';


// WEBPACK FOOTER //
// ./scripts/routes/common.js